module.exports = __webpack_public_path__ + "fonts/MavenPro-SemiBold.ae6950a5.ttf";